<template>
	<resource-list-item-skeleton title subtitle divided>

		<template #right>
			<chip-skeleton class="mr-4 md:mr-16" x-small :width="55"/>
			<Icon v-if="props.hasTo" :icon="icons.next" color="gray-400" class="block"/>
		</template>

		<div class="mt-4">
			<skeleton :height="12" :width="220" rounded class="mb-10"/>
			<skeleton :height="12" :width="120" rounded class="mb-4"/>
		</div>
	</resource-list-item-skeleton>
</template>

<script setup lang="ts">
import {nextIcon} from "../../config";

const props = defineProps<{
	hasTo?: boolean,
}>();

const icons = {
	next: nextIcon,
};
</script>